import {
  LayoutDashboardIcon,
  CalendarIcon,
  UsersIcon,
  ListTodoIcon,
  PlusCircleIcon,
  ClipboardListIcon,
  ReceiptIcon,
  WalletIcon,
  FileBarChartIcon,
  FileTextIcon,
  ShieldIcon,
  BatteryChargingIcon,
  ListChecksIcon,
  SparklesIcon,
} from 'lucide-react'
import { View } from '../types/view'

export interface NavItem {
  id: View
  label: string
  icon: typeof LayoutDashboardIcon
  /** Only visible to users with the Admin role. */
  adminOnly?: boolean
  /** Small accent pill shown after the label, e.g. "NY". */
  badge?: string
}

export interface NavGroup {
  /** Uppercase section label. Omit for the top, unlabelled group. */
  label?: string
  items: NavItem[]
}

export const navGroups: NavGroup[] = [
  {
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: LayoutDashboardIcon,
      },
      {
        id: 'calendar',
        label: 'Kalender',
        icon: CalendarIcon,
      },
    ],
  },
  {
    label: 'Salg',
    items: [
      {
        id: 'customers',
        label: 'Kunder',
        icon: UsersIcon,
      },
      {
        id: 'tasks',
        label: 'Opgaver',
        icon: ListTodoIcon,
      },
      {
        id: 'add-task-page',
        label: 'Tilføj opgave',
        icon: PlusCircleIcon,
        adminOnly: true,
      },
      {
        id: 'mester-ai',
        label: 'Mester-AI',
        icon: SparklesIcon,
        badge: 'NY',
      },
    ],
  },
  {
    label: 'Drift',
    items: [
      {
        id: 'manage-tasks-page',
        label: 'Ændre opgaver',
        icon: ClipboardListIcon,
        adminOnly: true,
      },
      {
        id: 'quality',
        label: 'Kvalitetssikring',
        icon: ListChecksIcon,
      },
      {
        id: 'invoices',
        label: 'Fakturaer',
        icon: ReceiptIcon,
      },
      {
        id: 'payouts',
        label: 'Udbetalinger',
        icon: WalletIcon,
        adminOnly: true,
      },
      {
        id: 'report',
        label: 'Rapport',
        icon: FileBarChartIcon,
      },
      {
        id: 'regelgrundlag',
        label: 'Regelgrundlag',
        icon: FileTextIcon,
      },
    ],
  },
  {
    label: 'System',
    items: [
      {
        id: 'users',
        label: 'Brugere',
        icon: ShieldIcon,
        adminOnly: true,
      },
      {
        id: 'charger-settings',
        label: 'Information',
        icon: BatteryChargingIcon,
        adminOnly: true,
      },
    ],
  },
]
